<template>
  <div style="margin-bottom: 60px;height: auto;">
    <div style="margin-top:40px;">
      <div class="nav-content">
        <inform-left v-if="isNav" :left="left"></inform-left>
        <inform-right-vue :right="right"></inform-right-vue>
      </div>
    </div>
  </div>
</template>

<script>
import informLeft from "./informLeft.vue";
import informRightVue from "./informRight.vue";
export default {
  name: "informNotice",
  components: {
    informLeft,
    informRightVue
  },
  watch: {
    $route: {
      handler: function(to, from) {
        this.getNav().then(() => {
          let path = this.$route.path;
          //判断如果为产品介绍部分的话，我们则动态获取LEFT的所有数据传过去直接进行渲染，
          if (path === "/Portal/solution") {
            if (!this.$route.query.tagnum) {
              this.$router.push({
                path: "/Portal/solution",
                query: {
                  tagnum: 201
                }
              });
            }
            this.isNav = true;
            let item = this.navList1[1];
            let infos = {
              state: true,
              rootId: item.id,
              nav: "123",
              num: "other"
            };
            this.cmsInfo = infos;
            //我们请求并筛选了左侧组件所需要的所有数据并存入left中
            this.getNav1().then(() => {
              this.left = {
                list: this.list,
                title: this.title,
                introduce: this.introduce
              };
              //我们在这里获取右侧组件所需要的所有数据并存入right中
              let rightnum = this.$route.query.tagnum;
              let zzz = (rightnum % 10) - 1;
              this.right = {
                cmsId: this.list[zzz].cmsId,
                title: this.title,
                name: this.list[zzz].title
              };
            });
          } else if (path === "/Portal/info") {
            this.isNav = false;
            let item = this.navList1[3];
            //我们在这里获取右侧组件所需要的所有数据并存入right中
            this.right = {
              cmsId: item.cmsId,
              title: item.title,
              name: ""
            };
          } else if (path === "/Portal/guide") {
            this.isNav = false;
            let item = this.navList1[4];
            //我们在这里获取右侧组件所需要的所有数据并存入right中
            this.right = {
              cmsId: item.cmsId,
              title: item.title,
              name: ""
            };
          } else if (path === "/Portal/work") {
            this.isNav = false;
            let item = this.navList1[2];
            //我们在这里获取右侧组件所需要的所有数据并存入right中
            this.right = {
              cmsId: item.cmsId,
              title: item.title,
              name: ""
            };
          }
        });
      },
      deep: true
    }
  },
  data() {
    return {
      isNav: false,
      navList1: [],
      cmsInfo: {},
      list: [],
      title: "",
      introduce: "",
      left: {},
      right: {}
    };
  },
  mounted() {
    this.getNav().then(() => {
      let path = this.$route.path;
      //判断如果为产品介绍部分的话，我们则动态获取LEFT的所有数据传过去直接进行渲染，
      if (path === "/Portal/solution") {
        if (!this.$route.query.tagnum) {
          this.$router.push({
            path: "/Portal/solution",
            query: {
              tagnum: 201
            }
          });
        }
        this.isNav = true;
        let item = this.navList1[1];
        let infos = {
          state: true,
          rootId: item.id,
          nav: "123",
          num: "other"
        };
        this.cmsInfo = infos;
        //我们请求并筛选了左侧组件所需要的所有数据并存入left中
        this.getNav1().then(() => {
          this.left = {
            list: this.list,
            title: this.title,
            introduce: this.introduce
          };
          //我们在这里获取右侧组件所需要的所有数据并存入right中
          let rightnum = this.$route.query.tagnum;
          let zzz = (rightnum % 10) - 1;
          this.right = {
            cmsId: this.list[zzz].cmsId,
            title: this.title,
            name: this.list[zzz].title
          };
        });
      } else if (path === "/Portal/info") {
        this.isNav = false;
        let item = this.navList1[3];
        //我们在这里获取右侧组件所需要的所有数据并存入right中
        this.right = {
          cmsId: item.cmsId,
          title: item.title,
          name: ""
        };
      } else if (path === "/Portal/guide") {
        this.isNav = false;
        let item = this.navList1[4];
        //我们在这里获取右侧组件所需要的所有数据并存入right中
        this.right = {
          cmsId: item.cmsId,
          title: item.title,
          name: ""
        };
      } else if (path === "/Portal/work") {
        this.isNav = false;
        let item = this.navList1[2];
        //我们在这里获取右侧组件所需要的所有数据并存入right中
        this.right = {
          cmsId: item.cmsId,
          title: item.title,
          name: ""
        };
      }
    });
  },
  methods: {
    sortby(prop, rev = true) {
      return function(a, b) {
        var val1 = a[prop];
        var val2 = b[prop];
        return rev ? val1 - val2 : val2 - val1;
      };
    },
    getNav() {
      return new Promise((resolve, reject) => {
        GMS.$http
          .get("/home/getNavigation")
          .then(res => {
            if (res.status == 200) {
              let data = res.data;
              let navList = [];
              for (let i = 0; i < data.length; i++) {
                if (!data[i].parent) {
                  data[i].childList = [];
                  navList.push(data[i]);
                }
              }
              let childList = data.filter(item => {
                return item.parent;
              });
              for (let i = 0; i < navList.length; i++) {
                for (let j = 0; j < childList.length; j++) {
                  if (navList[i].id == childList[j].parent) {
                    navList[i].childList.push(childList[j]);
                  }
                }
              }
              navList.sort(this.sortby("ordina"));
              this.navList1 = JSON.parse(JSON.stringify(navList));
              resolve();
            }
          })
          .catch(error => {
            this.$Message.error("获取数据异常", error);
          });
      });
    },
    getNav1() {
      return new Promise((resolve, reject) => {
        const info = this.cmsInfo;
        const ind = info.nav;
        const rootId = info.rootId;
        GMS.$http
          .get("/home/getNavigation")
          .then(res => {
            if (res.status != 200) {
              // TODO 给出异常提示
              // this.$Message.error("获取数据异常，请联系管理员");
              return;
            }
            let data = res.data;
            let currentGroup = data.find(el => el.id == rootId);
            if (!currentGroup) {
              this.list = [];
              console.error("未获取到指定的导航分组信息");
              return;
            }
            currentGroup.childList = data.filter(
              item => item.parent == currentGroup.id
            );
            currentGroup.childList.sort(this.sortby("ordina"));
            this.title = currentGroup.title;
            this.list = currentGroup.childList;
            this.introduce = currentGroup.shortName;
            resolve();
          })
          .catch(error => {
            // this.$Message.error("获取数据异常，请联系管理员");
            console.error(`获取解析导航栏信息异常：${error}`);
          });
      });
    }
  }
};
</script>

<style lang="less" scoped>
.nav-content {
  width: 1200px;
  margin: 0 auto;
}
@media screen and (max-width: 1500px) {
  .nav-content {
    width: 1200px;
  }
}
@media screen and (min-width: 1500px) and (max-width: 1800px) {
  .nav-content {
    width: 1400px;
  }
}
@media screen and (min-width: 1800px) {
  .nav-content {
    width: 1600px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/inside/inforNotice.vue